import axios from 'axios';
import { component } from 'picoapp';
import moment from 'moment';
import getClient from './sanity';

export default component((node, ctx) => {
  const sidebarLinks = node.querySelectorAll('.account-sidebar-link');
  const sections = node.querySelectorAll('.account-section');
  sidebarLinks.forEach(link => {
    link.addEventListener('click', () => {
      sidebarLinks.forEach(link => {
        link.classList.remove('is-active');
      });
      link.classList.add('is-active');

      sections.forEach(section => {
        if (section.id === link.dataset.section) {
          section.classList.add('is-active');
        } else {
          section.classList.remove('is-active');
        }
      });
    });
  });

  const tabLinks = node.querySelectorAll('.account-tab-link');
  const tabs = node.querySelectorAll('.account-tab');
  tabLinks.forEach(link => {
    link.addEventListener('click', () => {
      tabLinks.forEach(link => {
        link.classList.remove('is-active');
      });
      link.classList.add('is-active');

      tabs.forEach(section => {
        if (section.id === link.dataset.tab) {
          section.classList.remove('hidden');
        } else {
          section.classList.add('hidden');
        }
      });
    });
  });

  if (window.location.hash == '#orders') {
    setTimeout(() => {
      const tab = document.querySelector('[data-tab="recent-tab"]');
      tab.click();
    }, 0);
  }
  if (window.location.hash == '#saved-creations') {
    setTimeout(() => {
      const tab = document.querySelector('[data-tab="saved-creations"]');
      tab.click();
    }, 0);
  }

  const render = node.querySelector('.js-recent-creations');

  const getCreations = async () => {
    const client = await getClient();
    const identifier = node.dataset.email.replace(/[^a-zA-Z0-9]/g, '_');
    const query = `*[_type == "creation" && identifier == "${identifier}"] | order(_createdAt desc)`;

    client.fetch(query, {}).then(creations => {
      console.log('~', creations);
      let html = '';
      let product = '';

      creations.forEach(creation => {
        if (creation.type === 'blush') {
          product = `
          <div class="relative">
            <div class="w-[80%] h-[80%] absolute top-[10%] left-[10%]" style="border-radius: 100%; background-color: ${creation.hex}">&nbsp;</div>
            <img src="${node.dataset.blush}" class="max-h-[226px] h-full relative object-contain" />
          </div>
          `;
        }

        if (creation.type === 'lipgloss') {
          product = `
          <div class="relative">
            <div class="w-[95%] h-[86%] absolute top-[10%] left-[2.5%]" style="background-color: ${creation.hex}">&nbsp;</div>  
            <img src="${node.dataset.lipgloss}" class="h-full max-h-[300px] relative object-contain" />
          </div>
          `;
        }

        const createdAt = moment(creation._createdAt).format('MMMM Do YYYY');

        const urlParameters = new URLSearchParams({
          name: creation.name,
          color: creation.hex.replace('#', ''),
          saved: true,
        });

        const separator = creation.url.includes('?') ? '&' : '?';
        const url = `${creation.url}${separator}${urlParameters}`;

        html += `
          <div class="text-center mt-[50px] relative account-creation" style="background-color: rgba(255, 0, 0, 0)" id="id_${
            creation._id
          }">
            <div class="heading-2"><i>${creation.name}</i></div>
            <div class="my-[10px] subheading-2">Created On ${createdAt}</div>
            <div class="aspect-square relative flex items-center justify-center">
              ${product}
            </div>
            <div class="">
              <div class="inline-flex items-center">
                
                <div>
                  <div class="subheading-2">Color</div>
                  <div class="w-[120px] h-[30px] sm:h-[30px] rounded-[6px] my-[5px] js-custom-color border-[1px] border-black" style="background-color: ${
                    creation.hex
                  }">
                    &nbsp;
                  </div>
                  <div class="flex justify-between">
                    <div class="subheading-2 subheading-2 mt-[3px]">${
                      creation.hex
                    }</div>
                    <a href="${url}&section=color" class="text-[12px] font-gt underline link-opacity">Edit</a>
                  </div>
                </div>


                ${
                  !!creation.fragrance
                    ? `
                  <div class="ml-[30px]">
                    <div class="subheading-2">Fragrance</div>
                    <div class="w-[120px] h-[30px] my-[5px] flex items-center justify-center">
                      <span>${creation.fragrance}</span>
                    </div>
                    <a href="${url}&section=fragrance" class="text-[12px] font-gt underline link-opacity">Edit</a>
                  </div>
                `
                    : ``
                }
                
              </div>
            </div>

            <button type='button' class='button loading button--m w-full mt-[20px] bg-chocolate' data-url="${creation.url}" data-hex="${creation.hex}" data-name="${creation.name}" onClick="addCreationToCart(this)">Add To Cart
            <div class="loading-overlay__spinner hidden">
              <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
              </svg>
            </div>
            </button>

            <div class="absolute top-[5px] sm:top-[11px] right-0">
              <a href="#" class="js-delete-creation" data-id="id_${
                creation._id
              }" data-name="${creation.name}">
                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17">
                  <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
                </svg>
              </a>
            </div>
          </div>
        `;
      });
      render.innerHTML = html;

      const deleteButtons = render.querySelectorAll('.js-delete-creation');
      deleteButtons.forEach(button => {
        button.addEventListener('click', e => {
          e.preventDefault();
          console.log('e');
          var result = confirm(
            `Are you sure you want to delete ${e.target.dataset.name}?`,
          );
          if (result) {
            client.delete(e.target.dataset.id).then(() => {
              document.getElementById(e.target.dataset.id).remove();
            });
          }
        });
      });

      const checkOos = async (url) => {
        const urlParams = new URLSearchParams(url.split("?")[1]);
        let variantId = urlParams.get("variant");
        try {
          if (variantId) {
            const response = await fetch(`/variants/${variantId}.js`);
            const data = await response.json();
            return !data.available;
          } else {
            const productName = url.split("/")[2].split("?")[0];
            const response = await fetch(`/products/${productName}.js`);
            const data = await response.json();
            return !data.variants[0].available;
          }
        } catch (error) {
          console.error(error);
        }
      };
      creations.forEach(async creation => {
        let isOos = await checkOos(creation.url);
        const btn = render.querySelector(`#id_${creation._id} button[data-url='${creation.url}'`);
        if (isOos) {
          btn.disabled = true;
          btn.innerHTML = window.variantStrings.soldOut;
        }
        btn.classList.remove('loading');
      })


    });
  };
  getCreations();

  addCreationToCart = async (creation) => {
		console.log(creation);
		const cart = document.querySelector("cart-drawer");
		const url = creation.dataset.url;
		const hex = creation.dataset.hex;
		const name = creation.dataset.name;

		const productName = url.split("/")[2].split("?")[0];

		const urlParams = new URLSearchParams(url.split("?")[1]);
		let variantId = urlParams.get("variant");

		const properties = {
			Color: hex,
		};
		if (name != "") {
			properties["Creation Name"] = name;
		}

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';

    config.body = {
      items: [
        {
         id: parseInt(variantId),
         quantity: 1,
         properties: properties,
        }
      ],
      sections: cart
        .getSectionsToRender()
        .map((section) => section.id),
    };

		if (variantId) {
        config.body = JSON.stringify(config.body);
        fetch(`${routes.cart_add_url}`,config)
				.then((response) => response.json())
				.then((data) => {
          if (data.status) {
					  alert(`An error occured: ${data.description}`);
            console.log(data);
            return;
          }
          cart.classList.remove('is-empty');
					cart.renderContents(data);
				})
				.catch((error) => {
					alert(`An error occured: ${error}`);
				});
		} else {
			fetch(`/products/${productName}.js`)
				.then((response) => response.json())
				.then((data) => {
          config.body.items[0].id = data.variants[0].id;
          config.body = JSON.stringify(config.body);
					fetch(`${routes.cart_add_url}`,config)
						.then((response) => response.json())
						.then((data) => {
              if (data.status) {
                alert(`An error occured: ${data.description}`);
                console.log(data);
                return;
              }
              cart.classList.remove('is-empty');
							cart.renderContents(data);
						})
						.catch((error) => {
							console.log(`An error occured: ${error}`);
						});
				})
				.catch((error) => {
					console.log(`An error occured: ${error}`);
				});
		}
	};

  return;

  const currentStatus = node.querySelector('.MemberStatus__CurrentStatus i');
  const memberPoints = node.querySelector('.MemberStatus__Points i');
  const memberName = node.querySelector('.MemberStatus__MemberName i');
  const memberSince = node.querySelector('.MemberStatus__MemberSince i');
  const pointsFill = node.querySelector('.MemberStatus__PointsBarFill');

  axios
    .get(
      `https://app.swellrewards.com/api/v2/customers?customer_email=${node.dataset.email}&merchant_id=17000&with_history=true&api_key=u9N91hrRyZSrrrI0S5wQrgtt`,
    )
    .then(({ data }) => {
      setMemberInfo(data);
    });

  var setMemberInfo = function (member_info) {
    console.log('~', member_info);
    memberPoints.textContent = member_info.points_balance;
    memberName.textContent = `${member_info.first_name} ${member_info.last_name}`;

    if (member_info.history_items.length > 0) {
      memberSince.textContent = new Date(
        member_info.history_items[0].created_at,
      ).getFullYear();
    }

    let score = member_info.total_spend_cents / 100;
    // let score = 5000 / 100;

    if (score >= 0 && score < 250) {
      currentStatus.textContent = 'FF Insider';
    } else if (score >= 250 && score < 500) {
      currentStatus.textContent = 'FF Signature';
    } else if (score >= 500) {
      currentStatus.textContent = 'FF Elite';
    }

    pointsFill.style.width = Math.floor((score / 500) * 100) + '%';
  };
});
